import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '营养方案', path: '/category?tab=yingyang' },
    { label: '早教方案', path: '/category?tab=zaojiao' },
    { label: '习惯培养', path: '/category?tab=xiguan' },
    { label: '关于我们', path: '/about' },
  ],
  热门文章: [
    { label: '3岁营养全解析', path: '/article/sansui-yingyang-peifang' },
    { label: '早教方案详解', path: '/article/sansui-zaojiao-fangan' },
    { label: '好习惯养成记', path: '/article/sansui-xiguan-peiyang' },
    { label: '运动指南', path: '/article/sansui-yundong-zhinan' },
  ],
  联系我们: [
    { label: '客服热线：400-123-4567', path: 'tel:400-123-4567' },
    { label: '邮箱：hello@ohpwbf.cn', path: 'mailto:hello@ohpwbf.cn' },
    { label: '地址：上海市浦东新区张江高科技园区', path: '#' },
    { label: '工作时间：周一至周五 9:00-18:00', path: '#' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubscribeStatus('success');
      setSubscribeMsg('感谢订阅！');
      setEmail('');
      return;
    }
    setSubscribeStatus('loading');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9u18ddca23r0tr1aoi0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const code = (parsed as { code?: string }).code;
      if (res.ok && code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！我们会定期发送育儿干货到您的邮箱。');
        setEmail('');
      } else {
        setSubscribeStatus('error');
        const serverMsg = (parsed as { meta?: { message?: string } }).meta?.message
          || (parsed as { message?: string }).message
          || responseText;
        setSubscribeMsg(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后再试');
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-3-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">悠宝三岁</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为3岁宝宝打造的科学成长方案，用爱与专业陪伴每个家庭度过关键发育阶段。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith('/') ? (
                      <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                        {link.label}
                      </Link>
                    ) : link.path.startsWith('tel:') || link.path.startsWith('mailto:') ? (
                      <a href={link.path} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                        {link.label}
                      </a>
                    ) : (
                      <span className="text-sm text-foreground-600">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 悠宝三岁 版权所有 | 沪ICP备2024000000号
          </p>
          <form data-readdy-form="true" onSubmit={handleSubscribe} className="flex items-center gap-2">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" className="honeypot-field" />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入邮箱，订阅育儿资讯"
              required
              className="px-4 py-2 text-sm bg-background-50 border border-background-300 rounded-full w-52 md:w-64 outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              disabled={subscribeStatus === 'loading'}
              className="px-4 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {subscribeStatus === 'loading' ? '提交中...' : '订阅'}
            </button>
          </form>
          {subscribeStatus !== 'idle' && (
            <p className={`text-xs ${subscribeStatus === 'success' ? 'text-accent-600' : 'text-primary-600'}`}>
              {subscribeMsg}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}